
import {
    defineComponent, computed, toRefs, unref, PropType, SetupContext,
} from '@vue/composition-api';
import RadioInput from '@ve/components/inputs/RadioInput.vue';
import TextCommon from '@ve/components/inputs/TextCommon.vue';
import FilterListItem from '@ve/components/searchFilters/filterList/desktop/FilterListItem.vue';
import FiltersListSection from '@ve/components/searchFilters/filterList/desktop/FiltersListSection.vue';
import Rating from '@ve/components/icons/rating/Rating.vue';
import FilterItemPosition from '@ve/components/filters/common/components/filterItemPosition/FilterItemPosition.vue';
import { SerpHotelAdapted } from '@ve/components/searchFilters/store/types';
import FilterAttributeRatingReviewsMethods from './filterMethods/FilterAttributeRatingReviewsMethods';
import { idsRating } from './types';

export default defineComponent({ //todo: Дописать компонент FilterListRender, чтобы можно было передавать в него компоненты как слоты.
    name: 'rating-reviews-filter',
    components: {
        RadioInput,
        FilterListItem,
        FiltersListSection,
        FilterItemPosition,
        TextCommon,
        Rating,
    },
    model: {
        prop: 'selected',
        event: 'change',
    },
    props: {
        selected: {
            type: Number as PropType<idsRating>,
            default: 0,
        },
        allHotels: {
            type: Array as PropType<SerpHotelAdapted[]>,
            default: () => [],
        },
        filteredHotels: {
            type: Array as PropType<SerpHotelAdapted[]>,
            default: () => [],
        },
        visibleCounter: {
            type: Boolean,
            default: true,
        },
    },
    setup(props, { emit }: SetupContext) {
        const { selected, filteredHotels, allHotels } = toRefs(props);
        const selectedValue = computed({
            get: () => unref(selected),
            set: (value) => {
                emit('change', value);
            },
        });

        const countRatingFilteredHotels = computed(() => FilterAttributeRatingReviewsMethods.getCountAttribute(unref(filteredHotels)));

        const isHasOneRatingByAllHotels = computed(() => FilterAttributeRatingReviewsMethods.getIsOneHotelHasProperty(unref(allHotels)));

        return {
            reviewsRatings: FilterAttributeRatingReviewsMethods.getListFilterAttributes(),
            selectedValue,
            countRatingFilteredHotels,
            isHasOneRatingByAllHotels,
            FilterAttributeRatingReviewsMethods,
        };
    },
});
